import axios, { AxiosResponse } from 'axios';
import { manualContractData } from '../types/interfaces';
import { secureGet, securePatch, securePost } from '../utils/HttpUtils';

const apiUrls = {
  base: '/v1/private/',
  clients: '/v1/private/clients/',
  applications: '/v1/private/applications/',
  templates: '/v1/private/templates',
};

export const getTemplates = async () => {
  const url = apiUrls.templates;
  return secureGet(url);
};

export const getContracts = async (applicationId: number) => {
  const url = apiUrls.applications + applicationId + '/contracts';
  return secureGet(url);
};

export const sendContractTemplate = async (
  contractTemplate: string,
  contractInfo: any
) => {
  const url = apiUrls.base + 'templates/' + contractTemplate;
  return securePost(url, contractInfo, 'application/json', 'arraybuffer');
};

export const signContract = async (
  id: string | undefined,
  contractTemplate: string | undefined,
  signers: any,
  file: File
) => {
  const url = apiUrls.applications + id + '/contracts/external';
  const formData = new FormData();
  formData.append('template_name', contractTemplate || '');
  formData.append('signers', JSON.stringify(signers));
  formData.append('file', file);
  return securePost(url, formData, 'multipart/form-data');
};

export const signManualContract = async (
  id: string | undefined,
  manualContractData: manualContractData,
  file: File
) => {
  const url = apiUrls.applications + id + '/contracts/manual';
  const formData = new FormData();
  formData.append('template_name', manualContractData.template_name);
  formData.append('book_location', manualContractData.book_location);
  formData.append('file', file);
  return securePost(url, formData, 'multipart/form-data');
};

export const deleteContractFile = async (
  applicationId: string | undefined,
  contractId: string
) => {
  const url =
    apiUrls.applications + applicationId + '/contracts/' + contractId + '/REJ';
  return securePatch(url, {});
};

export const downloadContractFile = async (
  cuit: string | undefined,
  applicationId: string | undefined,
  fileName: string
) => {
  const token = localStorage.getItem('token');
  try {
    const response: AxiosResponse = await axios.get(
      apiUrls.clients +
      cuit +
      '/applications/' +
      applicationId +
      '/contracts/' +
      fileName,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }
    );
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
};

export const activateClientLines = async (cuit: string | undefined, id: string | undefined) => {
  const url =
    apiUrls.clients +
    cuit +
    '/applications/' +
    id +
    '/approved-product-lines/instrumentation';
  return securePost(url, {});
};

export const getInstrumentationId = async (
  cuit: string | undefined,
  applicationId: string | undefined,
) => {
  const url = apiUrls.clients + cuit + '/applications/' + applicationId + '/guarantees/setup';
  return securePost(url, {});
};

export const getInstrumentationStatus = async (
  applicationId: string | undefined
) => {
  const url = apiUrls.applications + applicationId + '/instrumentation/status';
  return secureGet(url);
};